var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.61382,
    cy: 8.98857,
    rx: 8.38726,
    ry: 8.1331,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9687 4.52734C7.9687 4.25767 8.18731 4.03906 8.45698 4.03906C8.72665 4.03906 8.94525 4.25767 8.94525 4.52734V13.3163C8.94525 13.586 8.72665 13.8046 8.45698 13.8046C8.18731 13.8046 7.9687 13.586 7.9687 13.3163V4.52734Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06249 9.4101C3.79283 9.4101 3.57422 9.19149 3.57422 8.92182C3.57422 8.65216 3.79283 8.43355 4.06249 8.43355L12.8515 8.43355C13.1211 8.43355 13.3397 8.65215 13.3397 8.92182C13.3397 9.19149 13.1211 9.4101 12.8515 9.4101L4.06249 9.4101Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.074cefb8e592a36ae4e44dcfab6edee0.svg";
export { ForwardRef as ReactComponent };